export const SHOW_GLOBAL_LOADER = 'SHOW_GLOBAL_LOADER';
export const SHOW_GLOBAL_LOADER_ERROR = 'SHOW_GLOBAL_LOADER_ERROR';
